import { useSessionStorage } from 'usehooks-ts';

import { getOrderFormSessionKey, OrderData } from 'support/helpers/orderForms/orderForms';

const defaultOrderData: OrderData = {
  products: {},
};

export const useOrderData = (supplierSlug: string, initialData: OrderData = defaultOrderData) => {
  const sessionStorageKey = getOrderFormSessionKey(supplierSlug);
  return useSessionStorage<OrderData>(sessionStorageKey, initialData);
};

export const clearOrderData = (supplierSlug: string) => {
  const sessionStorageKey = getOrderFormSessionKey(supplierSlug);
  sessionStorage.removeItem(sessionStorageKey);
};
